<template>
  <h5 v-show="showTitle">Repairs</h5>
  <span>{{ title }}</span>
  <div class="row">
    <!-- Search -->
    <div class="col-2">
      <z-search v-model.trim="searchTerm" name="search" label="" placeholder="Search" :readonly="isLoading" />
    </div>
    <!-- Filter -->
    <div class="col-2 custom-filter">
      <i class="fas fa-filter col-1 custom-filter-icon"></i>
      <z-select class="col" v-model="filterBy" :options="filterOptions"></z-select>
    </div>
    <!-- Placeholder -->
    <div class="col-3">
      <Multiselect ref="searchLocation" v-model="foundLocation" class="form-control custom-multiselect"
        placeholder="type to search for a location" :close-on-select="true" :filter-results="false" :min-chars="1"
        :resolve-on-load="false" :delay="500" :searchable="true" :open-direction="'bottom'" :options="async (query) => {
          return await fetchLocations(query)
        }
          " label="firmName" value-prop="firm" @select="selectedLocation" @clear="clearSelection" />
    </div>
    <!-- #668: new VIN-only inspection, same as ADAS Map's list Add -->
    <div class="col-auto">
      <button class="btn btn-primary" :disabled="isLoading" title="Add a new ADAS inspection from a VIN" @click="$emit('add')">
        <i class="fas fa-plus me-1"></i> Add
      </button>
    </div>
    <!-- Issue 622: Upload a PDF estimate (opens the Upload PDF page). Sits between the location filter and paging. -->
    <div v-if="isAllowed('/upload-estimate')" class="col-auto">
      <button class="btn btn-primary" :disabled="isLoading" title="Upload a PDF estimate" @click="$emit('upload')">
        <i class="fas fa-file-upload me-1"></i> Upload PDF
      </button>
    </div>
    <div class="col">
      <!-- Pager and count size to their content, so the pager can't overflow onto the count -->
      <div class="row align-items-center justify-content-end">
        <!-- Pagination -->
        <div class="col-auto">
          <z-select v-model="pageSize" :options="pageSizes" label="" name="pageSize" :disabled="isLoading" />
        </div>
        <div class="col-auto">
          <nav>
            <z-paginate v-model="page" :page-count="pages" />
          </nav>
        </div>
        <div class="col-auto text-nowrap">
          <h5 class="d-inline me-1" title="# items">{{ numItems }}</h5>
          <span class="custom-items">items</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { inspectionStore } from '@/stores/inspection'
import { locationStore } from '@/stores/location'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZPaginate from '@/components/utilities/elements/Paginate.vue'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'BlueprintHeader',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate,
    Multiselect
  },
  props: {
    pages: Number,
    pageSizes: Array,
    numItems: Number,
    showTitle: {
      type: Boolean,
      default: true
    },
    firm: Object
  },
  data() {
    return {
      title: '',
      foundLocation: null
    }
  },
  emits: ['search', 'add', 'upload'],
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, ['lookups']),
    ...mapState(inspectionStore, ['loading', 'listParams']),
    ...mapState(locationStore, ['locationsFound']),
    isLoading() {
      return this.loading.inspections
    },
    page: {
      get() {
        return this.listParams.page
      },
      set(value) {
        this.setListParam({
          name: 'page',
          value: parseInt(value)
        })
        this.search('')
      }
    },
    pageSize: {
      get() {
        return this.listParams.pageSize
      },
      set(value) {
        this.setListParam({
          name: 'pageSize',
          value: parseInt(value)
        })
        this.page = 1
      }
    },
    filterBy: {
      get() {
        return this.listParams.status
      },
      set(value) {
        this.setListParam({
          name: 'status',
          value: value
        })
        this.page = 1
      }
    },
    searchTerm: {
      get() {
        return this.listParams.searchTerm
      },
      set(value) {
        this.setListParam({
          name: 'searchTerm',
          value: value
        })
        this.page = 1
        this.change()
      }
    },
    filterOptions() {
      let _options = []
      console.log('Lookups', this.lookups)
      if (this.lookups['Status']) {
        _options = this.lookups['Status']
          .filter((x) => {
            return !['Archive'].includes(x.name)
          })
          .map((x) => {
            return {
              value: x.value,
              name: x.name
            }
          })
      }
      const _additional = [
        { value: '', name: 'All' }
      ]
      _options = [..._additional, ..._options]

      return _options
    }
  },
  methods: {
    ...mapActions(inspectionStore, ['setListParam']),
    ...mapActions(locationStore, ['searchLocations']),
    ...mapActions(authStore, ['isAllowed']),
    setFilter() {
      this.foundLocation = this.listParams.filter ? this.listParams.filter : null
      this.selectedLocation()
    },
    change() {
      this.search(this.listParams.searchTerm)
    },
    search() {
      this.$emit('search', this.page)
    },
    async fetchLocations(query) {
      let search = {
        searchterm: query,
        lookup: 5, // provider only
        firm: this.profile.firm
      }
      return await this.searchLocations(search)
    },
    clearSelection() {
      this.setListParam({
        name: 'filter',
        value: null
      })
      this.setListParam({
        name: 'firm',
        value: this.profile.firm
      })
      this.page = 1
      this.$emit('search', 1)
    },
    selectedLocation() {
      console.log('Selected Location', this.foundLocation)
      this.$nextTick(() => {
        let found = this.locationsFound.find((x) => parseInt(x.firm) === parseInt(this.foundLocation))
        if (found) {
          this.setListParam({
            name: 'firm',
            value: found.firm
          })
          this.page = 1
        }
      })
    }
  }
}
</script>
<style lang="scss">
.custom-filter {
  position: relative;
  display: inline-flex;
}

.custom-filter-icon {
  top: 8px;
  font-size: 1.2em;
}

.filterListing {
  float: left;
}

.custom-items {
  font-size: 0.9em;
}

.custom-multiselect {
  top: -2px;
  height: 42px;
  padding: 0;
}
</style>
